// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"59d815ff","455":"4a6651ff"}[chunkId] + ".chunk.js";
};